import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";
import { cn } from "@ui/lib/utils";
import { cva } from "class-variance-authority";
import { Check } from "lucide-react";
import type { VariantProps } from "class-variance-authority";

export const checkboxVariants = cva(
  [
    "group/checkbox transition-all",
    "peer shrink-0 rounded-[4px]",
    "border-2 border-border-5",
    "hover:border-border-4",
    "focus:bg-primary-lighter3",
    "disabled:opacity-30",
    "data-[state=checked]:bg-background-2 data-[state=checked]:border-background-2 data-[state=checked]:hover:bg-background-5 data-[state=checked]:hover:border-background-5 data-[state=checked]:focus:bg-background-1 data-[state=checked]:focus:border-background-1 data-[state=checked]:disabled:opacity-30",
  ],
  {
    variants: {
      size: {
        small: "h-4 w-4",
        normal: "h-6 w-6",
      },
      hasError: {
        true: "border-error!",
      },
    },
    defaultVariants: {
      size: "normal",
    },
  }
);

type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> &
  VariantProps<typeof checkboxVariants>;

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, size, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxVariants({ size, className }))}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="text-white" size={size === "small" ? 12 : 18} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
